import {createContext} from 'react'

interface ExtensionContext {
  isStreaming?: boolean
}

/**
 * Shared context for React blocks to get state.
 */
export const ExtensionContext = createContext<ExtensionContext>({})

try{ ExtensionContext.displayName ||= 'ExtensionContext' } catch {}